export default "__VITE_ASSET__B8iRH3Lj__"